import React from 'react';
import Modal from '../Modal/Modal';
import CalendarPatientEvent from './CalendarPatientEvent';
import { useTreatmentContext } from '../../Services/TreatmentContext';
import { IResponse } from '../../Services/ApiClient';
// @ts-ignore
import styles from './CalendarTermPicker.module.scss';
import { HealthPlanCode } from '../../Enums/HealthPlanCode.enum';

interface ICalendarPatientEventModal {
	opened: boolean;
	onClose: any;
	onEventIsCreated?: (response: IResponse) => void;
	selectedDate: any;
	patientId?: string;
	caseId?: string;
	workplaceId?: string;
	defaultData?: any;
	params?: any;
	meddibaby?: boolean;
	healthPlanCode?: HealthPlanCode;
}

export default function CalendarPatientEventModal(
	props: ICalendarPatientEventModal,
) {
	const {
		opened,
		onClose,
		selectedDate,
		patientId,
		caseId,
		workplaceId,
		defaultData,
		params,
		onEventIsCreated,
		healthPlanCode,
	} = props;
	const { isCase } = useTreatmentContext();

	return (
		<div className={styles.wrapper}>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
				<Modal.Header
					title={
						defaultData ? 'base.editPatientOrder' : 'base.shared.orderAPatient'
					}
					firstUpper
				/>
				<Modal.Content contentScroll={true}>
					<CalendarPatientEvent
						healthPlanCode={healthPlanCode}
						caseId={caseId}
						order={defaultData}
						selectedDate={selectedDate}
						patientId={patientId}
						onSuccess={onClose}
						workplaceId={workplaceId}
						params={params}
						onEventIsCreated={onEventIsCreated}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
}
